// extracted by css-extract-rspack-plugin
export default {"container":"container-f7Ezi0"};